export const sortByProperty = (property) => (a, b) =>
  a[property] > b[property] ? 1 : b[property] > a[property] ? -1 : 0;
